import React from "react";
import { Box, Button, Modal, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";

const InstructionsModal = ({ open, onClose, exercise }) => (
  <Modal open={open} onClose={onClose}>
    <Box
      sx={{
        bgcolor: "background.paper",
        p: { xs: 2, md: 4 },
        m: "auto",
        mt: { xs: 2, md: 8 },
        width: "95%",
        maxWidth: 700,
        borderRadius: 3,
        maxHeight: "90vh",
        overflowY: "auto",
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography variant="h5" fontWeight="bold">
          {exercise.name}
        </Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </Box>

      {exercise.video && (
        <Box sx={{ mb: 3 }}>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            startIcon={<PlayCircleOutlineIcon />}
            href={exercise.video}
            target="_blank"
            size="large"
          >
            Ver Video Demostrativo
          </Button>
        </Box>
      )}

      {exercise.description && (
        <Box sx={{ mb: 3, p: 2, bgcolor: "action.hover", borderRadius: 2 }}>
          <Typography variant="body1">{exercise.description}</Typography>
        </Box>
      )}

      <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
        📋 Instrucciones
      </Typography>
      <Box component="ol" sx={{ pl: 2 }}>
        {exercise.instructions?.map((inst, idx) => (
          <Box component="li" key={idx} sx={{ mb: 1.5 }}>
            <Typography variant="body2">{inst}</Typography>
          </Box>
        ))}
      </Box>

      <Button
        fullWidth
        variant="outlined"
        onClick={onClose}
        sx={{ mt: 3 }}
      >
        Cerrar
      </Button>
    </Box>
  </Modal>
);

export default InstructionsModal;
